import { conferenceDetailState } from '../../models/callModel';
import { Types }from '../action/action';

const initialState = {
  isConference: false,
  isNewCall:false,
  list: {
    confid: '',
    host_callid: '',
    host_confdisplayname: '',
    host_entity: '',
    userCount: '',
    userList: []
  },
  isSuccess: false,
  callDetails: []
};

export const conferenceDetails = (state:conferenceDetailState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.UPDATDE_CONFERENCE_LIST:
    return {
      ...state, list: payloads.list, isConference: payloads.checkConf, isSuccess: true, isNewCall:payloads.isNewCall
    };
  case Types.UPDATDE_CONFERENCE_NEWCALL:
    return {
      ...state, isNewCall: payloads
    };
  case Types.CONFERENCE_USER_LIST:
    return {
      ...state, callDetails: payloads
    };
  default:
    return state;
  };
};